export const lightTheme = {
    text: "rgb(20, 20, 20)",
    text2: "rgb(55, 55, 55)",
    primary: "#000000",
    primary2: "#ffffff",
    bg: "rgb(252, 252, 252)",
    bg2: "rgb(225, 225, 225)",
    card: "#f8f8f8",
    topheader: "#212529",
    bottomheader: "#f8f8f8",
    arrowIcon: "#d9534f",
    jencoRed: "#d9534f",
    transparent: 'transparent',
};

export const darkTheme = {
    text: "rgb(245, 245, 245)",
    text2: "rgb(210, 210, 210)",
    textInvert: "rgb(20, 20, 20)",
    textInvert2: "rgb(55, 55, 55)",
    primary: "rgb(200, 117, 196)",
    primary2: "rgb(200, 117, 147)",
    bg: "rgb(3, 3, 3)",
    bg2: "rgb(30,30,30)",
};